import { LocalStorageCompatible } from './local-storage-compatible';
import { LocalStorageV0 } from './local-storage-v0';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export async function upgrade(raw: LocalStorageCompatible): Promise<LocalStorageV0> {
  // Sentinel Value. There is no previous versions.
  // This code will reach here only when user tamper with his/her own localstorage.
  return { version: 0, data: {} };
}
